export default "__VITE_ASSET__DzZ6uOUQ__"